import { e as events, V as VIEW_ONLINE, a as addCartLocation, b as addCartCTAType, c as productLists, r as refinementStateChangedActionNames, v as virtualPagesNames, d as virtualPagesTypes, f as virtualPagesNestedLocations, E as EXTERNAL_PARTNER_NAME, g as rangeTabs, O as ONLINE_VIEW, G as GLOBAL_ANALYTICS_EVENT_NAME, h as GLOBAL_PAGE_LOAD_UPDATE_EVENT_NAME } from './analytics-765d4daf.js';
import './request.constants-deb285e0.js';
import { g as getAddToCartLocation, a as getPageSubSubCategory, s as setActualNoParam, c as convertProductsPriceToFloat } from './utils-913bdf8a.js';
import { g as getLookupValueProductLists, a as getLookupValueVirtualPageName, b as getLookupValuePageTabs } from './lookups-705fb53e.js';

const ONLINE_SOFTWARE = 'Online Software';
const PDP_SOFTWARE = 'Software';
const ONLINE_CONFIGURATOR = 'Online Configurator';
const CONFIGURATOR = 'Configurator';
const CTA_TYPES = {
    ONLINE_SOFTWARE,
    PDP_SOFTWARE,
    ONLINE_CONFIGURATOR,
    CONFIGURATOR,
    BUY_ONLINE: 'buy-online',
    REQUEST_DEMO: 'request-demo',
    SOFTWARE_FREE_TRIAL: 'software-free-trial',
};
const ONLINE_CTA_TYPES = {
    [ONLINE_SOFTWARE]: true,
    [ONLINE_CONFIGURATOR]: true,
    [CTA_TYPES.BUY_ONLINE]: true,
    [CTA_TYPES.REQUEST_DEMO]: true,
    [CTA_TYPES.SOFTWARE_FREE_TRIAL]: true,
};

var __rest$1 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
const productSelectorAddToCartEvent = (params) => {
    const { products } = params;
    const ctaType = products.length > 1
        ? addCartCTAType.BUTTON_GROUP_OF_PRODUCTS
        : addCartCTAType.BUTTON_SINGLE_PRODUCT;
    return Object.assign({ event: events.ADD_TO_CART, addToCartLocation: getAddToCartLocation(params, addCartLocation.PRODUCT_SELECTOR, ctaType) }, params);
};
const addToCartRelatedProductsEvent = (params) => {
    return Object.assign({ event: events.ADD_TO_CART, addToCartLocation: getAddToCartLocation(params, productLists.RELATED_PRODUCTS_MODAL, addCartCTAType.BUTTON_SINGLE_PRODUCT) }, params);
};
const addToCartMainEvent = (params) => {
    const { isSticky } = params, rest = __rest$1(params, ["isSticky"]);
    const location = isSticky ? addCartLocation.STICKY_BAR : addCartLocation.PRODUCT_MAIN;
    return Object.assign({ event: events.ADD_TO_CART, addToCartLocation: getAddToCartLocation(params, location, addCartCTAType.BUTTON_SINGLE_PRODUCT) }, rest);
};
const addToCartProductCardEvent = (params) => {
    const { isGridView } = params, rest = __rest$1(params, ["isGridView"]);
    const location = isGridView ? productLists.GRID_VIEW_PRODUCTS : productLists.LIST_VIEW_PRODUCTS;
    return Object.assign({ event: events.ADD_TO_CART, addToCartLocation: getAddToCartLocation(params, location, addCartCTAType.BUTTON_SINGLE_PRODUCT) }, rest);
};
const addToCartSubstitution = (params) => {
    const { products } = params;
    const ctaType = products.length > 1
        ? addCartCTAType.BUTTON_GROUP_OF_PRODUCTS
        : addCartCTAType.BUTTON_SINGLE_PRODUCT;
    return Object.assign({ event: events.ADD_TO_CART, addToCartLocation: getAddToCartLocation(params, productLists.SUBSTITUTE_PRODUCTS, ctaType) }, params);
};
const addToCartAlternative = (params) => {
    return Object.assign({ event: events.ADD_TO_CART, addToCartLocation: getAddToCartLocation(params, productLists.ALTERNATIVE_PRODUTS, addCartCTAType.BUTTON_SINGLE_PRODUCT) }, params);
};
const downloadDocumentEvent = (params) => {
    return Object.assign({ event: events.DOWNLOAD_DOCUMENT }, params);
};
const documentDownloadEvent = (params) => {
    const { isViewOnline, documentName } = params, rest = __rest$1(params, ["isViewOnline", "documentName"]);
    return Object.assign({ event: events.DOWNLOAD, documentName: isViewOnline ? VIEW_ONLINE : documentName }, rest);
};
const removeFromFavoritesEvent = (params) => {
    return Object.assign({ event: events.REMOVE_FROM_CART }, params);
};
const refinementStateChangedEvent = (params) => {
    const { isChecked } = params, rest = __rest$1(params, ["isChecked"]);
    return Object.assign({ event: events.FILTER_CLICK, filterAction: isChecked
            ? refinementStateChangedActionNames.FILTER_SELECTED
            : refinementStateChangedActionNames.FILTER_DESELECTED }, rest);
};
const productVariantsClickEvent = (params) => {
    const { currency } = params, product = __rest$1(params, ["currency"]);
    const listValue = getLookupValueProductLists(productLists.VARIANTS);
    return {
        event: events.PRODUCT_VIEW,
        currencyCode: currency,
        list: listValue,
        products: [product],
    };
};
const buyOnlineClickEvent = (params) => {
    return Object.assign({ event: events.VIRTUAL_PAGE_VIEW, fromWebView: false, pageSubSubCategory: getPageSubSubCategory(params, virtualPagesTypes.MODAL_WINDOW, virtualPagesNames.BUY_ONLINE) }, params);
};
const documentsDownloadClickEvent = (params) => {
    return Object.assign({ event: events.VIRTUAL_PAGE_VIEW, fromWebView: false, pageSubSubCategory: getPageSubSubCategory(params, virtualPagesTypes.MODAL_WINDOW, virtualPagesNames.DOWNLOAD) }, params);
};
const paginationClickEvent = (params) => {
    const { pageNoParam, articleTitle } = params;
    let page = '';
    if (pageNoParam) {
        const currentUrl = window.decodeURI(window.location.href);
        page = setActualNoParam(currentUrl, pageNoParam);
    }
    return {
        event: events.VIRTUAL_PAGE_VIEW,
        fromWebView: false,
        pageSubSubCategory: getPageSubSubCategory(params, virtualPagesTypes.PAGINATION),
        page,
        articleTitle,
    };
};
const onlineSoftwareModalClickEvent = (type) => {
    const virtualPageName = type === ONLINE_SOFTWARE || type === PDP_SOFTWARE
        ? virtualPagesNames.SEE_SOFTWARE
        : virtualPagesNames.SEE_CONFIGURATOR;
    return {
        event: events.VIRTUAL_PAGE_VIEW,
        fromWebView: false,
        pageSubSubCategory: getPageSubSubCategory(null, virtualPagesTypes.MODAL_WINDOW, virtualPageName),
    };
};
const mediaGalleryPopupEvent = () => {
    return {
        event: events.VIRTUAL_PAGE_VIEW,
        fromWebView: false,
        pageSubSubCategory: getPageSubSubCategory(null, virtualPagesTypes.MODAL_WINDOW, virtualPagesNames.MEDIA_GALLERY),
    };
};
const hmcEvent = (params) => {
    const { pageCategoryId } = params;
    return Object.assign({ event: events.VIRTUAL_PAGE_VIEW, fromWebView: false, pageSubSubCategory: getPageSubSubCategory(params, virtualPagesTypes.MODAL_WINDOW, virtualPagesNames.HELP_ME_CHOOSE) }, (pageCategoryId && { pageCategoryId }));
};
const productSelectorVirtualPageEvent = (params) => {
    const { location, pageRangeId } = params || {};
    const rest = pageRangeId ? { pageRangeId } : {};
    let articleTitle = '';
    if (location === virtualPagesNestedLocations.HELP_ME_CHOOSE) {
        articleTitle = getLookupValueVirtualPageName(location);
    }
    return Object.assign({ event: events.VIRTUAL_PAGE_VIEW, fromWebView: false, pageSubSubCategory: getPageSubSubCategory(params, virtualPagesTypes.MODAL_WINDOW, virtualPagesNames.PRODUCT_SELECTOR), articleTitle }, rest);
};
const virtualPageRelatedProductsEvent = (params) => {
    return {
        event: events.VIRTUAL_PAGE_VIEW,
        fromWebView: false,
        pageSubSubCategory: getPageSubSubCategory(params, virtualPagesTypes.MODAL_WINDOW, virtualPagesNames.RELATED_PRODUCTS),
    };
};
const buyOnlineVirtualPageEvent = () => {
    return {
        event: events.VIRTUAL_PAGE_VIEW,
        fromWebView: false,
        pageSubSubCategory: getPageSubSubCategory(null, virtualPagesTypes.MODAL_WINDOW, virtualPagesNames.BUY_ONLINE),
    };
};
const filtersVirtualPageEvent = () => {
    return {
        event: events.VIRTUAL_PAGE_VIEW,
        fromWebView: false,
        pageSubSubCategory: getPageSubSubCategory(null, virtualPagesTypes.MODAL_WINDOW, virtualPagesNames.FILTERS),
    };
};
const mainDocumentsDropDownEvent = (params) => {
    return {
        event: events.VIRTUAL_PAGE_VIEW,
        fromWebView: false,
        pageSubSubCategory: getPageSubSubCategory(params, virtualPagesTypes.MODAL_WINDOW, virtualPagesNames.MAIN_DOCUMENTS),
    };
};
const rangeTabClickEvent = (params) => {
    const { tabHash } = params;
    const tabsArticleTitle = rangeTabs[tabHash];
    const articleTitle = getLookupValuePageTabs(tabsArticleTitle);
    return {
        event: events.VIRTUAL_PAGE_VIEW,
        fromWebView: false,
        pageSubSubCategory: getPageSubSubCategory(params, virtualPagesTypes.TABS_ON_RANGE),
        articleTitle,
    };
};
const videoStartEvent = (params) => {
    return Object.assign({ event: events.VIDEO_START }, params);
};
const videoCompleteEvent = (params) => {
    return Object.assign({ event: events.VIDEO_COMPLETE }, params);
};
const clickExternalPartnerLinkEvent = ({ 
// eslint-disable-next-line @typescript-eslint/naming-convention
external_partner_url, }) => {
    return {
        event: events.CLICK_EXTERNAL_PARTNER_LINK,
        external_partner_name: EXTERNAL_PARTNER_NAME,
        external_partner_url,
    };
};
const exitToSchneiderEvent = ({ 
// eslint-disable-next-line @typescript-eslint/naming-convention
link_url, }) => {
    return {
        event: events.EXIT_TO_SCHNEIDER,
        link_url,
    };
};
const viewExternalPartnerLink = ({ 
// eslint-disable-next-line @typescript-eslint/naming-convention
external_partner_url, 
// eslint-disable-next-line @typescript-eslint/naming-convention
external_partner_name, }) => {
    return {
        event: events.VIEW_EXTERNAL_PARTNER_LINK,
        external_partner_name,
        external_partner_url,
    };
};
const viewItemEvent = (params) => {
    return Object.assign({ event: events.VIEW_ITEM }, params);
};
const csExitToSchneiderEvent = ({ 
// eslint-disable-next-line @typescript-eslint/naming-convention
link_url, }) => {
    return {
        event: events.CS_EXIT_TO_SCHNEIDER,
        link_url,
    };
};

var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
const addToCart = (param) => {
    const { products } = param, rest = __rest(param, ["products"]);
    const newProducts = convertProductsPriceToFloat(products);
    return Object.assign({ products: newProducts }, rest);
};
const removeFromCart = (param) => {
    const { products } = param, rest = __rest(param, ["products"]);
    const newProducts = convertProductsPriceToFloat(products);
    return Object.assign({ products: newProducts }, rest);
};
const download = (param) => {
    const { documentReference, documentId, documentName } = param, rest = __rest(param, ["documentReference", "documentId", "documentName"]);
    return Object.assign(Object.assign({}, rest), { documentId: documentId || documentReference, documentName: documentName === ONLINE_VIEW || documentName === VIEW_ONLINE ? VIEW_ONLINE : documentName, event: events.DOWNLOAD });
};
const virtualPageview = (data) => {
    const { page } = data;
    if (page) {
        return data;
    }
    const currentUrl = window.decodeURI(window.location.href);
    return Object.assign(Object.assign({}, data), { page: currentUrl });
};
const postProcessing = (data) => {
    switch (data.event) {
        case events.VIRTUAL_PAGE_VIEW:
            return virtualPageview(data);
        case events.ADD_TO_CART:
            return addToCart(data);
        case events.DOWNLOAD:
        case events.DOWNLOAD_DOCUMENT:
            return download(data);
        case events.REMOVE_FROM_CART:
            return removeFromCart(data);
        default:
            return data;
    }
};

const send = (eventDetailsBuilder, params) => {
    const event = new CustomEvent(GLOBAL_ANALYTICS_EVENT_NAME, {
        detail: postProcessing(eventDetailsBuilder(params)),
        bubbles: true,
        composed: true,
    });
    window.dispatchEvent(event);
};
const updatePageLoadData = (params) => {
    const event = new CustomEvent(GLOBAL_PAGE_LOAD_UPDATE_EVENT_NAME, {
        detail: params,
        bubbles: true,
        composed: true,
    });
    window.dispatchEvent(event);
};

export { addToCartSubstitution as A, rangeTabClickEvent as B, clickExternalPartnerLinkEvent as C, addToCartRelatedProductsEvent as D, filtersVirtualPageEvent as E, hmcEvent as F, ONLINE_CTA_TYPES as O, PDP_SOFTWARE as P, addToCartProductCardEvent as a, buyOnlineClickEvent as b, documentsDownloadClickEvent as c, downloadDocumentEvent as d, refinementStateChangedEvent as e, csExitToSchneiderEvent as f, paginationClickEvent as g, productVariantsClickEvent as h, addToCartMainEvent as i, productSelectorVirtualPageEvent as j, documentDownloadEvent as k, exitToSchneiderEvent as l, mainDocumentsDropDownEvent as m, mediaGalleryPopupEvent as n, onlineSoftwareModalClickEvent as o, productSelectorAddToCartEvent as p, buyOnlineVirtualPageEvent as q, removeFromFavoritesEvent as r, send as s, virtualPageRelatedProductsEvent as t, updatePageLoadData as u, viewItemEvent as v, videoCompleteEvent as w, videoStartEvent as x, viewExternalPartnerLink as y, addToCartAlternative as z };
